export const EXPENSE_CATEGORIES = [
  ['loyer', 'Loyer'], ['salaires', 'Salaires'], ['electricite_eau', 'Électricité / Eau'],
  ['internet_telephone', 'Internet / Téléphone'], ['transport', 'Transport'],
  ['fournitures', 'Fournitures'], ['entretien', 'Entretien'], ['marketing', 'Marketing'], ['autre', 'Autre'],
].map(([value, label]) => ({ value, label }));
export const EXPENSE_PAYMENT_METHODS = [
  ['espece', 'Espèces'], ['cheque', 'Chèque'], ['carte_bancaire', 'Carte bancaire'], ['virement', 'Virement'],
].map(([value, label]) => ({ value, label }));
export const expenseCategoryLabel = value => EXPENSE_CATEGORIES.find(item => item.value === value)?.label || value;
export const expensePaymentLabel = value => EXPENSE_PAYMENT_METHODS.find(item => item.value === value)?.label || value;
export const todayInCasablanca = () => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Africa/Casablanca', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(new Date());
